import { useEffect } from "react";
import { goToAccount } from "@/lib/account";

export const WaitlistModal = () => {
  useEffect(() => { goToAccount(); }, []);
  return null;
};
